import { FunctionComponent, useEffect } from 'react';
import { Box, Icon, chooseColor } from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './Error.module.scss';
import { useToken } from '../../../providers/Token.provider';
import { useLayout } from '../../../providers/Layout.provider';

const TransactionError: FunctionComponent = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'PaymentMethod' });
  const { token } = useToken();
  const { setLayoutInfo } = useLayout();
  useEffect(() => {
    setLayoutInfo(
      chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      70,
      32,
      0,
      false,
      true,
    );
  }, []);

  return (
    <div className={styles.lastMSGContainer}>
      <Box flx="col" minheight="80vh" ai="center" jc="center">
        <div className={styles.iconContainer}>
          <Icon icon="notAllowed" color="error" width="114px" height="114px" />
        </div>
        <h2 className={styles.header}>{t('failed')}</h2>
        <div className={styles.text}>{t('failMessage')}</div>
      </Box>
    </div>
  );
};

export default TransactionError;
